import { WorkShift } from '@@partner:types:app'
import { CRUD_Variables, PageInfo } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'
import { useMemo } from 'react'

export interface AllWorkShiftsQuery {
  allWorkShifts?: {
    edges: WorkShift[]
    pageInfo: PageInfo
  }
}

export interface AllWorkShiftsQueryVariables extends CRUD_Variables {}

export const GQL_QUERY_ALL_WORKSHIFTS = gql`
  query($pager: CommonPagerInput, $filter: NestedFilterInput, $sort: CommonSortInput) {
    allWorkShifts(pager: $pager, filter: $filter, sort: $sort) {
      edges {
        id
        startedAt
        finishedAt
        is_finished
        is_started
        status
        plannedStartAt
        plannedFinishAt
        assembler {
          id
          status
          shop_id
          first_name
          last_name
        }
      }
      pageInfo {
        page
        perPage
        lastPage
        next
      }
    }
  }
`

export const useFetchAllWorkShifts = (variables?: AllWorkShiftsQueryVariables) => {
  const { data, loading, error, refetch, fetchMore } = useQuery<AllWorkShiftsQuery, AllWorkShiftsQueryVariables>(
    GQL_QUERY_ALL_WORKSHIFTS,
    {
      variables,
      fetchPolicy: 'cache-and-network',
      skip: !variables
    }
  )

  const workshifts: WorkShift[] | undefined = useMemo(
    () => data?.allWorkShifts?.edges ?? [], [ data ]
  )

  const pageInfo = useMemo(
    () => data?.allWorkShifts?.pageInfo, [ data ]
  )

  const initHasMore = (data?.allWorkShifts?.pageInfo.lastPage ?? 0) > (data?.allWorkShifts?.pageInfo.page ?? 0)
  

  return {
    data,
    workshifts,
    pageInfo,
    initHasMore,
    dataWorkshifts: data,
    loadingWorkShifts: loading,
    errorWorkShifts: error,
    refetch,
    fetchMoreWorkShifts: fetchMore
  }
}